import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core';
import { Done as DoneIcon, Warning as WarningIcon } from '@material-ui/icons';
import classnames from 'classnames';
import { get } from 'lodash';

import { VISIBILITY_INTERNAL } from 'components/Chat/constants';
import Tooltip from 'components/Tooltip';

const styles = ({
  custom: {
    palette: { colorAccentPeach, colorSupportSlate },
  },
  palette: {
    common: { white },
    text,
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    messageInfoStatusIcon: {
      color: white,
      fontSize: 13,
      position: 'relative',
      top: unit / -4,
      verticalAlign: 'middle',
      '&$primary': {
        color: `${text.primary} !important`,
      },
    },
    primary: {},
    messageInfoStatusIconwarning: {
      fontSize: 13,
      position: 'relative',
      top: unit / -4,
      verticalAlign: 'middle',
      color: `${colorAccentPeach}`,
      '&$primary': {
        color: `${text.primary} !important`,
      },
    },
    messageInfoStatusWrapper: {
      display: 'inline-block',
      float: 'left',
    },
    tooltip: {
      backgroundColor: `${colorAccentPeach} !important`,
      color: text.primary,
      fontSize: '10px !important',
      textAlign: 'center',
      padding: '1px 3px',
      fontWeight: 600,
      top: 10,
      position: 'relative',
    },
  });

interface Props {
  isOutbound: boolean;
  message: any;
  classes: any;
}

const StatusIcon: React.FC<Props> = ({ isOutbound, message, classes }) => {
  const { status, visibility } = message;

  if (!isOutbound) return null;

  const singleCheck = (
    <div className={classes.messageInfoStatusWrapper}>
      <DoneIcon
        className={classnames(classes.messageInfoStatusIcon, {
          [classes.primary]: visibility === VISIBILITY_INTERNAL,
        })}
      />
    </div>
  );

  const doubleCheck = (
    <div className={classes.messageInfoStatusWrapper}>
      <DoneIcon
        className={classnames(classes.messageInfoStatusIcon, {
          [classes.primary]: visibility === VISIBILITY_INTERNAL,
        })}
      />
      <DoneIcon
        className={classnames(classes.messageInfoStatusIcon, {
          [classes.primary]: visibility === VISIBILITY_INTERNAL,
        })}
      />
    </div>
  );

  const undeliveredWarning = (
    <div className={classes.messageInfoStatusWrapper}>
      <Tooltip
        className={classes.tooltip}
        hideArrow
        title={get(message, 'externalStatus.reason') || 'This message could not be delivered'}
        placement="top-end"
      >
        <WarningIcon
          className={classnames(classes.messageInfoStatusIconwarning, {
            [classes.primary]: visibility === VISIBILITY_INTERNAL,
          })}
        />
      </Tooltip>
    </div>
  );

  switch (status) {
    case 'sent':
    case 'pending':
      return singleCheck;
    case 'delivered':
    case 'opened':
      return doubleCheck;
    case 'undelivered':
      return undeliveredWarning;
    default:
      return null;
  }
};

export default withStyles(styles)(StatusIcon);
